interface ButtonControls {
    lockButtons: () => void;
    releaseButtons: () => void;
}
  
export const createButtonControls = (
    setIsBackDisabled: React.Dispatch<React.SetStateAction<boolean>>,
    setIsNextDisabled: React.Dispatch<React.SetStateAction<boolean>>
  ): ButtonControls => {
    return {
      lockButtons: () => {
        setIsBackDisabled(true);
        setIsNextDisabled(true);
      },
      releaseButtons: () => {
        setIsBackDisabled(false);
        setIsNextDisabled(false);
      }
    };
  };